<template>
  <v-container class="text-center" fill-height style="height: calc(100vh - 64px);">
    <v-row align="center">
      <v-col>
        <h1 class="display-2 primary--text">Access denied</h1>

        <p>ไม่มีสิทธิ์ดำเนินการ กรุณาเข้าสู่ระบบเพื่อเข้าถึงข้อมูล</p>

        <v-btn @click="openLoginDialog()" color="primary" outlined>
          เข้าสู่ระบบ
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'Unauthorize',

  data() {
    return {
      previousUrl: '',
      previousGet: '',
      prevRoute: null,
      prevGet: null,
      is_login: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path;
      vm.prevGet = from.query;
    });
  },
  mounted() {
    // console.log(this.prevRoute);
    this.checkLoginState();
  },
  methods: {
    gotoPage(page) {
      this.$router.push({ name: page });
    },
    openLoginDialog() {
      this.$emit("unauthorized")
      this.$nextTick(() => {
        document.getElementById("login_btn").click()
      })
    },
    checkLoginState() {
      const accessToken = localStorage.getItem('access_token');
      const refreshToken = localStorage.getItem('refresh_token');
      const username = localStorage.getItem('username');

      if (accessToken && refreshToken && username) {
        console.log('Has Login');
        this.is_login = true;
      } else {
        console.log('No Login');
        this.is_login = false;
        this.openLoginDialog()
      }
    }
  },
  watch: {
    prevRoute(value) {
      this.previousUrl = value;
    },
    prevGet(value) {
      this.previousGet = value;
    },
    is_login(value) {
      if (value === true) {
        this.$router.go(-1);
      } else {
        this.openLoginDialog()
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
